import { statusLabel } from '@/lib/sales';
import { cn } from '@/lib/utils';

/** StatusBadge (document 05): text always present; colour only reinforces it. */
export function StatusBadge({
  kind,
  status,
  overdue,
  className,
}: {
  kind: string;
  status: string;
  overdue: boolean;
  className?: string;
}) {
  const label = statusLabel({ kind, status, overdue });
  const tone =
    status === 'void' || status === 'declined'
      ? 'border-border bg-muted text-muted-foreground line-through'
      : status === 'draft'
        ? 'border-border bg-muted text-foreground'
        : overdue
          ? 'border-destructive/30 bg-destructive/10 text-destructive'
          : status === 'paid' || status === 'converted' || status === 'accepted'
            ? 'border-success/30 bg-success/10 text-success'
            : status === 'partially_paid'
              ? 'border-warning/30 bg-warning/10 text-warning'
              : 'border-info/30 bg-info/10 text-info';
  return (
    <span
      data-testid="status-badge"
      className={cn(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        tone,
        className,
      )}
    >
      {label}
    </span>
  );
}
